import { __makeTemplateObject } from "tslib";
import { typography } from 'styled-system';
import styled from '@marvelapp/styled';
import { colors } from '@marvelapp/theme';
var ReadOnlyTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  display: block;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  word-break: break-word;\n"], ["\n  ", ";\n  color: ", ";\n  display: block;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  word-break: break-word;\n"])), typography, colors.licorice);
export default ReadOnlyTitle;
var templateObject_1;
